/*
 * Fixed bottom action bar for CreateEditIntakeView.
 *   edit:   Cancel | Save             (testid pw_if-save-btn)
 *   create: Cancel | Create intake form (testid pw_if-create-btn)
 * Container keeps data-testid="pw_if-action-bar" (preserved from wave-3 Task 3).
 *
 * SCSS → Tailwind mapping (ceiv-action-bar):
 *   position:fixed / bottom:0 / left:var(--nav-width) / right:0 / flex / items-center /
 *   justify-content:flex-end / gap:12px / padding:16px 24px / bg:#fff /
 *   border-top:1px solid --border-card(#141E1F1A) / z-index:100
 *   → fixed bottom-0 left-[var(--nav-width)] right-0 flex items-center justify-end gap-sp-1.5
 *     py-sp-2 px-sp-3 bg-white border-t border-shade-10 z-[100]
 *
 * Arbitrary values: left-[var(--nav-width)] (CSS var, no DS token), z-[100] (no DS token).
 */
import { Button } from '@quickmd-llc/design-system'

type Props = {
  isEdit?: boolean | undefined
  onCancelBtnPress?: (() => void) | undefined
  onSaveBtnPress: () => void
}

export function IntakeActionBar({ isEdit, onCancelBtnPress, onSaveBtnPress }: Props) {
  return (
    <div
      className='fixed bottom-0 left-[var(--nav-width)] right-0 z-[100] flex items-center justify-end gap-sp-1.5 border-t border-shade-10 bg-white px-sp-3 py-sp-2'
      data-testid='pw_if-action-bar'>
      <Button priority='secondary' size='m' onClick={onCancelBtnPress}>
        Cancel
      </Button>
      {isEdit ?
        <Button priority='primary' size='m' onClick={onSaveBtnPress} data-testid='pw_if-save-btn'>
          Save
        </Button>
      : <Button priority='primary' size='m' onClick={onSaveBtnPress} data-testid='pw_if-create-btn'>
          Create intake form
        </Button>
      }
    </div>
  )
}
